import { module } from 'angular';
import { react2angular } from 'react2angular';

import { ClusterMatches } from './ClusterMatches';

export interface IClusterMatch {
  name: string;
  account: string;
  regions: string[];
}

export const CLUSTER_MATCHES_COMPONENT = 'spinnaker.core.widget.cluster.clusterMatches.component';
module(CLUSTER_MATCHES_COMPONENT, [])
  .component('clusterMatches', react2angular(ClusterMatches, ['matches']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/widgets/cluster/clusterMatches.component.ts